var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.474934 3.458C0.190932 3.458 -0.0390695 3.221 0.0049308 2.941C0.279933 1.24 1.57594 0 3.82496 0C6.07498 0 7.59199 1.36 7.59199 3.215C7.59199 4.559 6.92699 5.503 5.80198 6.188C4.70197 6.847 4.38797 7.306 4.38797 8.198V8.228C4.38797 8.36061 4.33529 8.48779 4.24152 8.58155C4.14775 8.67532 4.02057 8.728 3.88796 8.728H3.11796C2.98621 8.72801 2.85978 8.67601 2.76616 8.58333C2.67253 8.49064 2.61927 8.36474 2.61795 8.233L2.61495 8.033C2.57195 6.812 3.09196 6.032 4.25996 5.321C5.28997 4.689 5.65698 4.186 5.65698 3.293C5.65698 2.314 4.89897 1.595 3.73096 1.595C2.72195 1.595 2.02095 2.124 1.79295 2.997C1.72694 3.251 1.51494 3.458 1.25294 3.458H0.475934H0.474934ZM3.49596 12C4.11796 12 4.59097 11.526 4.59097 10.91C4.59097 10.292 4.11796 9.818 3.49596 9.818C2.88995 9.818 2.40895 10.292 2.40895 10.909C2.40895 11.526 2.88995 12 3.49596 12Z",
    fill: "#1062D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAuth);
export default __webpack_public_path__ + "static/media/question-auth.beb4b6e67644a2cabb953258700f3d91.svg";
export { ForwardRef as ReactComponent };